var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgColorTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 11.017a9.407 9.407 0 01-2.592.675 4.347 4.347 0 001.984-2.375 9.3 9.3 0 01-2.866 1.041 4.591 4.591 0 00-2.561-1.3 4.72 4.72 0 00-2.865.45 4.388 4.388 0 00-1.984 2.017 4.097 4.097 0 00-.28 2.747 13.346 13.346 0 01-5.154-1.301 12.72 12.72 0 01-4.15-3.182 4.127 4.127 0 00-.61 2.157c-.001.706.182 1.402.532 2.025.35.623.857 1.154 1.475 1.546a4.683 4.683 0 01-2.044-.537v.056c0 .99.36 1.95 1.02 2.717a4.562 4.562 0 002.6 1.49 4.774 4.774 0 01-2.038.073c.288.853.85 1.598 1.606 2.132a4.67 4.67 0 002.61.847 9.362 9.362 0 01-5.606 1.837c-.36 0-.72-.02-1.077-.06A13.254 13.254 0 0013.918 26c8.303 0 12.843-6.537 12.843-12.207 0-.184-.005-.37-.014-.554a8.939 8.939 0 002.251-2.22l.002-.002z",
    fill: "#2E5ECC"
  })));
}

export default SvgColorTwitter;